import {
  // Box,
  Edit,
  Eye,
  Filter,
  // GitMerge,
  PlusCircle,
  // StopCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import Brand from "../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../Router/all_routes";
import Table2 from "../../core/pagination/datatable2";
// import { Download } from "react-feather";
import axios from "axios";
import { bucketObj } from "../../environment";
// import * as Icon from 'react-feather';
//set_page_refresh
import {set_product_list, set_product_edit, set_inventory_list} from "../../core/redux/action";
import { useNavigate } from "react-router-dom";

const ProductList = () => {
  
  const navigate = useNavigate();
  // const dataSource = useSelector((state) => state.product_list);
  const [productList, setProductList] = useState([])
  const [storeList, setStoreList] = useState([])
  const [selectedStore, setSelectedStore] = useState("");
  const [tenantId, setTenantId] = useState(null);

  const [allProducts, setAllProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const inventory = useSelector((state) => state.inventory_list);
  // const pageRefresh = useSelector((state) => state.pageRefresh?.productlist || 0);
  const [searchTerm, setSearchTerm] = useState("");
  const language = useSelector((state) => state.language || "en");
  const translation = useSelector((state) => state.translation || "en");
  const dispatch = useDispatch();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const route = all_routes;
  useEffect(() => {
  if (typeof window !== "undefined") {
    setTenantId(localStorage.getItem("tenantId"));
  }
}, []);
  useEffect(() => {
    let objPL = {};
    let obj = {};
    inventory.productList?.forEach((currP) => {
      let totalQuantity = 0;
      let attributeValues = [];
      let id = currP._id;
      obj[id] = totalQuantity;

      currP = JSON.parse(JSON.stringify(currP));
      currP.itemCount = obj[id];
      currP.attributeValue = attributeValues.join(",");

      objPL[id] = currP;
    });
    const stores = new Map();
    inventory?.productList?.forEach((product) => {
      if (!stores.has(product.storeId)) {
        stores.set(product.storeId, product.storeName);
      }
    });

    const storeOptionsList = localStorage.getItem('storeOptionsList');
    if (storeOptionsList) {
      setStoreList(JSON.parse(storeOptionsList));
    }

    const productArray = Object.values(objPL);
    setProductList(productArray);
    setAllProducts(productArray); // Store all products in a separate state
    setIsLoading(false); 
  }, [inventory]);
  
  useEffect(() => {
    if (selectedStore) {
      const filteredProducts = allProducts.filter(
        (product) => product.storeId === selectedStore
      );
      setProductList(filteredProducts);
    } else {
      // If no store is selected, show all products
      setProductList(allProducts);
    }
  }, [selectedStore, allProducts]);
  async function fetchData() {
    try
    {
      setIsLoading(true);
      let initCalls = {
        "getuserinventory/": set_inventory_list,
      };
      const storeIds = localStorage.getItem('storeIds');
      console.log("storeIds",storeIds);
      
      Object.keys(initCalls).forEach(async (k) => {
        let result = await axios.get(k, {
          params: {
            storeIds: storeIds, // Add query parameters here
          },
        });
        console.log('result.data',result.data);
        set_product_list(result.data.productList)
        dispatch(initCalls[k](result.data))
      })
    }
    catch (error) {
    console.error("Error during fetchData:", error);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    
    fetchData()
  }, [])

 
  useEffect(() => {
    let filteredProducts = [...allProducts]; 
    if (searchTerm && searchTerm !== "") {
    // Check if searchTerm is a number
    const isNumber = !isNaN(searchTerm);
  
    filteredProducts = filteredProducts.filter((product) => {
      // If searchTerm is a number, filter only by itemCount
      if (isNumber == true) {
        const res = (product.itemCount=== Number(searchTerm) && product.productType != "custom")
        return  res;
      }
      // If searchTerm is not a number, filter by name, category, and other conditions
      return (
        product._id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.categoryName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.itemCount?.toString().includes(searchTerm) ||
        product.chassisNumber?.toString().includes(searchTerm) ||
        //AXVH75
        product?.pStatus?.toLowerCase() === searchTerm.toLowerCase() || // Check for exact match
        (product?.pStatus?.toLowerCase() === "inactive" && searchTerm.toLowerCase() === "in active") // Additional check
      );
    });
  }
    setProductList(filteredProducts);
  }, [searchTerm, inventory, allProducts]);
  
  
   //Permissions  
   const permissions = useSelector(state => state.permissions) || [];
   const roleTitle = useSelector(state => state.roleTitle) || '';
   const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

   const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'products' && p.Permission.toLowerCase() === 'view');
   const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'products' && p.Permission.toLowerCase() === 'create');
   const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'products' && p.Permission.toLowerCase() === 'update');
   const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'products' && p.Permission.toLowerCase() === 'delete');

   if (!canView) {
       return (  
       <div className={`${language === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{translation?.[language]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
   )}
   //

  const columns = [
    
    {
      title: translation?.[language]?.["action"] ||"Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            <Link className="me-2 p-2 hidden" to={route.productdetails}>
              <Eye className="feather-view" />
            </Link>
            {canUpdate && ['active', 'inactive', 'showprice'].includes(record.pStatus) && (
              <Link  className="me-2 p-2" to={route.addproduct} onClick={() => {
                editProduct(record)
              }}>
                <Edit className="feather-edit" />
              </Link>
            )}
            {canDelete  && ['active', 'inactive', 'showprice'].includes(record.pStatus) && (
              <Link
                className="confirm-text p-2"
                to="#"
                onClick={(e) => showConfirmationAlert(e,record)}
              >
                <Trash2 className="feather-trash-2" />
              </Link>
            )}
          </div>
        </div>
      ),
    },
    {
      title: translation?.[language]?.["product_image"] || "Product Image",
      dataIndex: "imgUrls",
    
      render: (text) => (
      <span className="">
  {text && text[0] ? (
    /\.(mp4|webm|ogg)$/i.test(text[0]) ? (
      <video
        controls
        width="100%"
        src={text[0].startsWith('http') ? text[0] : bucketObj.bucketUrl + bucketObj.objectKey + text[0]}
      >
        Your browser does not support the video tag.
      </video>
    ) : (
      <img
        src={text[0].startsWith('http') ? text[0] : bucketObj.bucketUrl + bucketObj.objectKey + text[0]}
        alt="Product"
      />
    )
  ) : null}
</span>
     
      ),
    },
     {
      title: translation?.[language]?.["chassis_numbers"] || "Chassis Numbers",
      dataIndex: "chassisNumber",
      // sorter: (a, b) => a.product.length - b.product.length,
    },

    //  {
    //   title: translation?.[language]?.["id"] || "ID",
    //   dataIndex: "_id",
    
    //   render: (text) => (
    //     {tenantId == "n4Xc96g6qyNcrq5dD ? (
    //                   <span className="productimgname">PNC-{product._id}</span>)
    //                 ) : tenantId == "jNrhXAynhAbQkrj8Y" ? (
    //                   <span className="productimgname">JP-{product._id}</span>)
    //                 ) : (
    //                   <span className="productimgname">E-{product._id}</span>
    //                 )}

    //     // <span className="productimgname">PNC-{text}</span>
    //   ),
    //   // sorter: (a, b) => a.product.length - b.product.length,
    // },
    {
      title: translation?.[language]?.["id"] || "ID",
      dataIndex: "_id",
      render: (text) => {
        return tenantId === "n4Xc96g6qyNcrq5dD" ? (
          <span className="productimgname">PNC-{text}</span>
        ) : tenantId === "jNrhXAynhAbQkrj8Y" ? (
          <span className="productimgname">JP-{text}</span>
        ) : tenantId === "8wNWEtTEdgoywriNX" ? (
          <span className="productimgname">GTJ-{text}</span>
        ) :
        (
          <span className="productimgname">E-{text}</span>
        );
        //
        //
      }
    },
    
    
    {
      title: translation?.[language]?.["product"] || "Product",
      dataIndex: "name",
    
      render: (text) => (
        <span className="productimgname">{text}</span>
      ),
      // sorter: (a, b) => a.product.length - b.product.length,
    },
    
    // {
    //   title: translation?.[language]?.["store_name"] || "Store Name",
    //   dataIndex: "storeName",
     
    //   render: (text) => (
    //     <span className="">{text}</span>
    //   ),
    // },
    // {
    //   title: translation?.[language]?.["updated_date"] ||"Updated Date",
    //   dataIndex: "updatedAt",
    //   render: (text, record) => (
    //     <span className="userimgname">  {new Date(record?.updatedAt).toLocaleDateString()} </span>
        
    //   ),
    // },
    {
      title: translation?.[language]?.["updated_date"] || "Updated Date",
      dataIndex: "updatedAt",
      render: (text, record) => {
        const date = record?.updatedAt || record?.createdAt;
        return (
          <span className="userimgname">
            {date ? new Date(date).toLocaleDateString() : "-"}
          </span>
        );
      },
    },
    {
      title: translation?.[language]?.["pnc_purchased"] || "PNC Purchased",
      dataIndex: "myOwn",
      render: (text) => {
        if (text === true) {
          return <span className="">{translation?.[language]?.["yes"] || "Yes"}</span>;
        } 
        // else {
        //   return <span className="">{translation?.[language]?.["no"] || "No"}</span>;
        // }
      },
    },
    {
      title: translation?.[language]?.["reference_num"] || "Ref.",
      dataIndex: "carID",
     
      render: (text) => (
        <span className="">{text}</span>
      ),
    },
    {
      title: translation?.[language]?.["status"] ||"Status",
      dataIndex: "pStatus",
      render: (text) => {
        if(text == 'active')
          return <span className="" style={{color: "#0591BD"}}>{translation?.[language]?.[text]}</span>
        else if(text == 'inactive')
          return <span className="" style={{color: "#FF1E1E"}}>{translation?.[language]?.[text]}</span>
        else
          return <span className="" style={{color: "#0591BD"}}>{translation?.[language]?.[text] || text}</span>
      
      }
      // sorter: (a, b) => a.categoryName.length - b.categoryName.length,
    },
   
    // {
    //   title: translation?.[language]?.["category"] ||"Category",
    //   dataIndex: "categoryName",
    // },
    // {
    //   title: translation?.[language]?.["variation"] ||"Variation",
    //   dataIndex: "attributeValue",
    //   render(text, record) {
    //     if (record && record.productType != null && record.productType === "single")
    //     {
    //       return <span>{translation?.[language]?.["not_specified"] || "Not Specified"}</span>
    //     }
    //     else if(record?.productAttributes && record?.productAttributes.length > 0)
    //     {

    //       return <span>
    //         {record.productAttributes.map(product => {
    //             const attributes = product.attributes.map(attr => Object.values(attr)[0]);
    //             return attributes.join("|");
    //         }).join(", ")}
    //     </span>
    //     }
    //     else if(record?.attribute)
    //     {
    //       return <span>{record.variantName + ` ( ${record?.attribute?.reduce?.((s,a) => s+a.label, "")}) `}</span>
    //     }
    //     else
    //     {
    //       return <span>{translation?.[language]?.["not_specified"] || "Not Specified"}</span>
    //     }
    //   }
      
    // },
   
    // {
    //   title: translation?.[language]?.["quantity"] ||"Quantity",
    //   dataIndex: "qty",
    //   render(text, record) {
    //     if(record?.productType == 'custom')
    //     {
    //       return <span>{translation?.[language]?.["customized"] ||"Customized"}</span>
    //     }
    //     else
    //     {
    //       if(record?.generalProductType == "bid")
    //       {
    //         return <span>1</span>
    //       }
    //       else
    //       {
    //           return <span>{text?text:0}</span>
    //       }
    //     }
    //   }
    // },
    // {
    //   title: translation?.[language]?.["featured"] || "Featured",
    //   dataIndex: "featured",
    //   render: (text) => {
    //     if (text === true) {
    //       return <span className="">{translation?.[language]?.["yes"] || "Yes"}</span>;
    //     } else {
    //       return <span className="">{translation?.[language]?.["no"] || "No"}</span>;
    //     }
    //   },
    //   // sorter: (a, b) => a.categoryName.length - b.categoryName.length,
    // },    
    // {
    //   title: translation?.[language]?.["special"] ||"Special",
    //   dataIndex: "special",
    //   render: (text) => {
    //     if (text === true) {
    //       return <span className="">{translation?.[language]?.["yes"] || "Yes"}</span>;
    //     } else {
    //       return <span className="">{translation?.[language]?.["no"] || "No"}</span>;
    //     }
    //   },
    //   // sorter: (a, b) => a.categoryName.length - b.categoryName.length,
    // },    
    
    // {
    //   title: translation?.[language]?.["created_by"] ||"Created By",
    //   dataIndex: "createdBy.name",
    //   render: (text, record) => (
    //     <span className="userimgname">{record?.createdBy?.name} </span>
    //   ),
    //   // sorter: (a, b) => a.createdBy.length - b.createdBy.length,
    // },
    
  ];
  const MySwal = withReactContent(Swal);

  const editProduct = async (record) => {
    dispatch(set_product_edit(record))
    navigate(route.addproduct)
  }
  const showConfirmationAlert = (e,record) => {
    e.preventDefault();
    MySwal.fire({
      title: translation?.[language]?.["are_you_sure?"] || "Are you sure?",
      text: translation?.[language]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: translation?.[language]?.["yes,_delete_it!"] || "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: translation?.[language]?.["cancel"] || "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.post("removeproduct/", record);
          // dispatch(set_page_refresh("productlist"))
          fetchData();
          MySwal.fire({
            title: translation?.[language]?.["deleted!"] || "Deleted!",
            text: translation?.[language]?.["item_has_been_deleted."] || "Item has been deleted.",
            className: "btn btn-success",
            confirmButtonText: translation?.[language]?.["ok"] || "OK",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then(() => {
          });
        } catch(e) {
          console.log(e)
          return false;
        }
        
      } else {
        MySwal.close();
      }
    });
  };

  if (isLoading) {
    return <div>Loading products...</div>;
  }
  return (
    <div className={`${language === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{translation?.[language]?.["product_list"] || "Product List"}</h4>
              <h6>{translation?.[language]?.["manage_your_products"] || "Manage your products"}</h6>
            </div>
          </div>
          {/* reports */}
          
          <div className="search-set" style={{marginLeft: "auto"}}>
          <div className="search-input">
            <Select
              className="select2"
              options={storeList}
              value={storeList?.find(option => option.value === selectedStore)} // Handle the selected value
              onChange={(option) => setSelectedStore(option.value)} // Update the selected value
              placeholder={translation?.[language]?.["select_store_name"] || "Select Store Name"}
              styles={{
                container: (provided) => ({
                    ...provided,
                    minWidth: '150px', // Set your desired minimum width here
                    borderColor: '#e9edf6 !important',
                    lineHeight: '1.6',
                    borderRadius: '0.35rem',
                }),
            }}
            />
          </div>
            <div className="search-input">
              <input
                type="text"
                placeholder={translation?.[language]?.["search"] || "Search"}
                className="form-control"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span to="#" className="btn btn-searchset" style={{ paddingTop: "10px"}}>
                <i className="feather-search" />
              </span>
            </div>

              </div>
          {canCreate ? (
            <div className="page-btn">
               
              <Link to={route.addproduct} className="btn btn-added" onClick={() => dispatch(set_product_edit({}))}>
                <PlusCircle className="me-2 iconsize" />
                {translation?.[language]?.["add_new_product"] || "Add New Product"}
              </Link>
            </div>
           ) : null}
          
        </div>
       
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top hidden">
             
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
            </div>
          
            <div className="table-responsive">
              <Table2 columns={columns} dataSource={productList} />
            </div>
          </div>
        </div>
        {/* <Brand /> */}
      </div>
    </div>
  );
};

export default ProductList;



// const categorylist = [
  //   { value: "choose", label: "Choose Category" },
  //   { value: "laptop", label: "Laptop" },
  //   { value: "shoe", label: "Shoe" },
  // ];
  // const subcategorylist = [
  //   { value: "choose", label: "Choose Sub Category" },
  //   { value: "computers", label: "Computers" },
  //   { value: "fruits", label: "Fruits" },
  // ];
  // const brandlist = [
  //   { value: "all", label: "All Brand" },
  //   { value: "lenovo", label: "Lenovo" },
  //   { value: "nike", label: "Nike" },
  // ];
  // const price = [
  //   { value: "price", label: "Price" },
  //   { value: "12500", label: "$12,500.00" },
  //   { value: "13000", label: "$13,000.00" }, // Replace with your actual values
  // ];
  

  // <div className="page-btn import hidden">
  //           <Link
  //             to="#"
  //             className="btn btn-added color"
  //             data-bs-toggle="modal"
  //             data-bs-target="#view-notes"
  //           >
  //             <Download className="me-2" />
  //             Import Product
  //           </Link>
  //         </div>
    {/* /Filter */}
  //   <div
  //   className={`card${isFilterVisible ? " visible" : ""}`}
  //   id="filter_inputs"
  //   style={{ display: isFilterVisible ? "block" : "none" }}
  // >
  //   <div className="card-body pb-0">
  //     <div className="row">
  //       <div className="col-lg-12 col-sm-12">
  //         <div className="row">
  //           <div className="col-lg-2 col-sm-6 col-12">
  //             <div className="input-blocks">
  //               <Box className="info-img" />
  //               <Select
  //                 className="select"
  //                 options={productList}
  //                 placeholder="Choose Product"
  //               />
  //             </div>
  //           </div>
  //           <div className="col-lg-2 col-sm-6 col-12">
  //             <div className="input-blocks">
  //               <StopCircle className="info-img" />
  //               <Select
  //                 className="select"
  //                 options={categorylist}
  //                 placeholder="Choose Category"
  //               />
  //             </div>
  //           </div>
  //           <div className="col-lg-2 col-sm-6 col-12">
  //             <div className="input-blocks">
  //               <GitMerge className="info-img" />
  //               <Select
  //                 className="select"
  //                 options={subcategorylist}
  //                 placeholder="Choose Sub Category"
  //               />
  //             </div>
  //           </div>
  //           <div className="col-lg-2 col-sm-6 col-12">
  //             <div className="input-blocks">
  //               <StopCircle className="info-img" />
  //               <Select
  //                 className="select"
  //                 options={brandlist}
  //                 placeholder="Nike"
  //               />
  //             </div>
  //           </div>
  //           <div className="col-lg-2 col-sm-6 col-12">
  //             <div className="input-blocks">
  //               <i className="fas fa-money-bill info-img" />

  //               <Select
  //                 className="select"
  //                 options={price}
  //                 placeholder="Price"
  //               />
  //             </div>
  //           </div>
  //           <div className="col-lg-2 col-sm-6 col-12">
  //             <div className="input-blocks">
  //               <Link className="btn btn-filters ms-auto">
  //                 {" "}
  //                 <i
  //                   data-feather="search"
  //                   className="feather-search"
  //                 />{" "}
  //                 Search{" "}
  //               </Link>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // </div>
  {/* /Filter */}
{/* <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <i data-feather="printer" className="feather-printer" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul> */}

          // const renderTooltip = (props) => (
          //   <Tooltip id="pdf-tooltip" {...props}>
          //     Pdf
          //   </Tooltip>
          // );
          // const renderExcelTooltip = (props) => (
          //   <Tooltip id="excel-tooltip" {...props}>
          //     Excel
          //   </Tooltip>
          // );
          // const renderPrinterTooltip = (props) => (
          //   <Tooltip id="printer-tooltip" {...props}>
          //     Printer
          //   </Tooltip>
          // );
          // const renderRefreshTooltip = (props) => (
          //   <Tooltip id="refresh-tooltip" {...props}>
          //     Refresh
          //   </Tooltip>
          // );
          // const renderCollapseTooltip = (props) => (
          //   <Tooltip id="refresh-tooltip" {...props}>
          //     Collapse
          //   </Tooltip>
          // );